// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"190":"docs","191":"oxc-home","208":"oxc-me"}[chunkId] + "." + {"190":"48dd4358","191":"bbd6b7f3","208":"61390a44"}[chunkId] + ".css";
};